export type BankAccount = {
  bankName: string | null;
  accountName: string | null;
  accountNumber: string | null;
  isPrimary: boolean | null;
  currency: string | null;
  swift: string | null;
  iban: string | null;
};
